import { apiFetch } from "@/lib/api";

export const MANUFACTURING_PDD_CATCH_QUERY_KEY = ["manufacturing", "pdd-zpl-catch"] as const;

export type ManufacturingPddZplCatchKind = "unit" | "carton" | "other";

export type ManufacturingPddZplCatchJob = {
  id: string;
  filename: string;
  originalName: string;
  receivedAt: string;
  format: string;
  kind: ManufacturingPddZplCatchKind;
  printCopies: number;
  labelQty: number | null;
  catalog: string | null;
  sku: string | null;
  bytes: number;
};

export type ManufacturingPddZplCatchListResponse = {
  catchDir: string;
  available: boolean;
  jobs: ManufacturingPddZplCatchJob[];
};

export type ManufacturingPddZplCatchPreviewResponse = {
  id: string;
  kind: ManufacturingPddZplCatchKind;
  engine: "hub" | "labelary";
  pngBase64: string;
};

export type ManufacturingPddAssignResponse = {
  assigned: true;
  batchItemId: number;
  batchId: number;
  sku: string;
  quantity: number;
  pddSku: string | null;
  catalog: string | null;
  qtyWarning: string | null;
};

export async function fetchManufacturingPddCatch(): Promise<ManufacturingPddZplCatchListResponse> {
  return apiFetch<ManufacturingPddZplCatchListResponse>("/api/manufacturing/batch-details/pdd-catch");
}

export async function fetchManufacturingPddCatchPreview(
  id: string,
): Promise<ManufacturingPddZplCatchPreviewResponse> {
  const params = new URLSearchParams({ id });
  return apiFetch<ManufacturingPddZplCatchPreviewResponse>(
    `/api/manufacturing/batch-details/pdd-catch/preview?${params.toString()}`,
  );
}

export async function postManufacturingPddAssign(input: {
  batchId: number;
  batchItemId: number;
  unitId: string;
  cartonId: string;
}): Promise<ManufacturingPddAssignResponse> {
  return apiFetch<ManufacturingPddAssignResponse>(
    `/api/manufacturing/batch-details/batch/${String(input.batchId)}/lines/${String(input.batchItemId)}/pdd-labels`,
    {
      method: "POST",
      body: {
        unitId: input.unitId,
        cartonId: input.cartonId,
      },
    },
  );
}

export function manufacturingPddKindLabel(kind: ManufacturingPddZplCatchKind): string {
  if (kind === "unit") return "Unit";
  if (kind === "carton") return "Carton";
  return "Other";
}
